"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconStockOptions = function SvgIconStockOptions(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "stock options icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Stock Options Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.5 6C22.299 6 27 10.701 27 16.5c-.008 5.796-4.704 10.492-10.5 10.5C10.7 27 6 22.299 6 16.5S10.701 6 16.5 6zm0 2.475c-.587 0-1.069.45-1.12 1.023l-.005.102v.6a.372.372 0 01-.316.365 3.3 3.3 0 00-.803 6.246l.144.062 3.354 1.343a1.05 1.05 0 01-.29 2.032l-.102.002h-3.3a1.125 1.125 0 00-.102 2.245l.102.005H15c.184 0 .337.133.369.308l.006.067.004.537a1.125 1.125 0 002.246.102l.004-.102v-.6a.372.372 0 01.31-.37 3.3 3.3 0 00.804-6.246l-.145-.062-3.352-1.35a1.05 1.05 0 01.29-2.032l.101-.002h3.3a1.125 1.125 0 00.103-2.245l-.103-.005H18a.375.375 0 01-.369-.308l-.006-.067V9.6c0-.621-.504-1.125-1.125-1.125zM41.25 21.75a.75.75 0 01.75.75V30a.75.75 0 01-1.29.532l-2.192-2.193a.376.376 0 00-.52-.01l-7.57 6.98a3.246 3.246 0 01-4.208.15l-4.35-3.487a.376.376 0 00-.485.014l-10.732 9.54a1.876 1.876 0 01-2.49-2.805l10.97-9.75.33-.291a3.231 3.231 0 014.156-.107l4.35 3.476a.374.374 0 00.487-.018l6.875-6.338a.376.376 0 00.01-.541L33.22 23.03a.75.75 0 01.53-1.281h7.5z"
  }));
};

var _default = SvgIconStockOptions;
exports.default = _default;